import React from 'react'

const IconSpacer = ({ color = 'currentColor', ...rest }) => {
    return (
        <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
            <g clipPath='url(#clip0_3305_4913)'>
                <path
                    d='M8 1.3335V14.6668'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M5.33398 12L8.00065 14.6667L10.6673 12'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M5.33398 4.00016L8.00065 1.3335L10.6673 4.00016'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_3305_4913'>
                    <rect width='16' height='16' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export default IconSpacer
